import { FunctionComponent } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from '@cbridge-utils/react-redux';
import { ClientFeature, isAnyFeatureEnabledSelector } from '@cbridge-packages/auth';

interface IFeatureGuardProps {
  /** A feature, or a list of features of which any enabled one lets the nested routes render */
  feature: ClientFeature | ClientFeature[];
  redirectTo: string;
}

/**
 * Route guard that renders nested routes only when the given feature is enabled
 * (i.e. its name is not in the auth token's excludedScope). Otherwise redirects,
 * preventing direct URL access to a disabled page.
 */
export const FeatureGuard: FunctionComponent<IFeatureGuardProps> = ({ feature, redirectTo }) => {
  const features = Array.isArray(feature) ? feature : [feature];
  const isEnabled = useSelector(isAnyFeatureEnabledSelector, { features });

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return <Outlet />;
};
